import React,  { useState, useEffect, useContext } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import Stepper from '@material-ui/core/Stepper';
import StepConnector from '@material-ui/core/StepConnector';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Copyright from './Copyright'
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import HomeIcon from '@material-ui/icons/Home';
import Box from '@material-ui/core/Box';
import IconButton from '@material-ui/core/IconButton';
import './App.css';
import db from './constants/firebase';
import firebase from 'firebase/app';
import CssBaseline from '@material-ui/core/CssBaseline';
import Container from '@material-ui/core/Container';
import BasicInformation from './BasicInformation';
import TeamLogo from './TeamLogo';
import Roster from './Roster';
import Grid from '@material-ui/core/Grid';
import ApplicationFee from './ApplicationFee';
import VideoAudition from './VideoAudition';
import StepLabel from '@material-ui/core/StepLabel';
import Signature from './Signature';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Slide from '@material-ui/core/Slide';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});


const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  button: {
    marginRight: theme.spacing(1),
  },
  completed: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    height: 100,
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  root: {
    display: 'center',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  title: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logoutButton: props => ({
    background: props.palette.gradient.default,
    color: 'black',
  }),
  start: props => ({
    background: props.palette.gradient.default
  }),
}));

function getSteps() {
  return ['Basic Information', 'Team Logo', 'Roster', 'Application Fee', 'Video Audition', 'Signature'];
}
export default function Dashboard(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const [activeStep, setActiveStep] = React.useState(0);
  const [completed, setCompleted] = React.useState([]);
  const steps = getSteps();
  const [show, setShow] = useState(false);
  const [open, setOpen] = React.useState(false);

  const [snap, setSnap] = useState({
    BasicInformation: {
      completed: false
    },
    ApplicationFee: {
      completed: false
    },
    Roster: {
      completed: false
    },
    TeamLogo: {
      completed: false
    },
    VideoAudition: {
      completed: false
    },
    Signature: {
      completed: false
    },
    LastUpdated : "never"
  });

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  var completedVal = snap.BasicInformation.completed && 
  snap.ApplicationFee.completed && 
  snap.Roster.completed && 
  snap.TeamLogo.completed && 
  snap.VideoAudition.completed &&
  snap.Signature.completed

  var completedValwithoutSignature = snap.BasicInformation.completed && 
  snap.ApplicationFee.completed && 
  snap.Roster.completed && 
  snap.TeamLogo.completed && 
  snap.VideoAudition.completed


  useEffect(() => {
    const fs = db.firestore()
    var user = firebase.auth().currentUser;

    fs.collection("users").doc(user.email).get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setSnap(snapshot.data())
        } else {
          console.log("No data available");
        }
      }).catch((error) => {
        console.error(error);
      })
  }, [])

  const updateSnap = (completedSteps) => {
    const fs = db.firestore()
    var user = firebase.auth().currentUser;

    fs.collection("users").doc(user.email).get()
      .then((snapshot) => {
        if (snapshot.exists) {
          setSnap(snapshot.data())
        } else {
          console.log("No data available");
        }
      }).catch((error) => {
        console.error(error);
      })
  }

  const totalSteps = () => {
    return steps.length;
  };

  const completedSteps = () => {
    return Object.keys(completed).length;
  };

  const isLastStep = () => {
    return activeStep === totalSteps() - 1;
  };

  const allStepsCompleted = () => {
    return completedSteps() === totalSteps();
  };

  const handleNext = () => {
    const newActiveStep =
      isLastStep() && !allStepsCompleted()
        ? // It's the last step, but not all steps have been completed,
          // find the first step that has been completed
          steps.findIndex((step, i) => !(i in completed))
        : activeStep + 1;
    setActiveStep(newActiveStep);
    updateSnap();
    if (completedVal) {
      handleClickOpen();
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  function handleCompleted(index) {
    switch (index) {
      case 0:
        return snap.BasicInformation.completed;
      case 1:
        return snap.TeamLogo.completed;
      case 2:
        return snap.Roster.completed;
      case 3:
        return snap.ApplicationFee.completed;
      case 4:
        return snap.VideoAudition.completed;
      case 5:
        return snap.Signature.completed
      default:
        return false;
    }
  };

  const handleReset = () => {
    setActiveStep(0);
    setCompleted({});
  };

  const handleSignout = () => {
    firebase.auth().signOut().then(() => {
      history.push("/register");
    }).catch((error) => {
      // An error happened.
    });
  }

  const handleHome = () => {
    history.push("/")
  };

  const { history } = props;

  const BasicInformationProps = {
    data: snap.BasicInformation.data ? snap.BasicInformation.data : {},
    function: handleNext,
    updateSnap: updateSnap
  };

  const TeamLogoProps = { link: (snap.TeamLogo.link ? snap.TeamLogo.link : ""),
                          function: handleNext};

const RosterProps = { data: (snap.Roster.data ? snap.Roster.data : {}), 
                      function: handleNext};

const ApplicationFeeProps = { link: (snap.ApplicationFee.link ? snap.ApplicationFee.link : ""), 
                            function: handleNext };

const VideoAuditionProps = { link: (snap.VideoAudition.link ? snap.VideoAudition.link : ""), 
                            function: handleNext };

const SignatureProps = { link: (snap.Signature.link ? snap.Signature.link : ""), 
allcomplete: completedValwithoutSignature,
function: handleNext };


 function getStepContent(step) {
    switch (show) {
    case false:
      return (
        <Grid
          alignItems = "center"
          justifyContent ="center"
          container
                direction="column">
          <Button
          onClick={() => setShow(true)}
          className={classes.start}
        >
          {completedVal?  "Application already completed, Update Info?" : "Continue to Application"}
          </Button>
          <Box m = {5}/>
          {completedVal &&
          <Typography> Please remember that if you choose to update your info, your application submission time will be recorded as the time you last updated any information.</Typography>}
         </Grid>
      )
    default:
      switch (step) {
        case 0:
            return (
                <BasicInformation props={BasicInformationProps}></BasicInformation>
            )
        case 1:
          return (
              <TeamLogo props={TeamLogoProps}></TeamLogo>
          )
        case 2:
            return(
                <Roster props={RosterProps}> </Roster>
            )
        case 3: 
              return(
                  <ApplicationFee props={ApplicationFeeProps}> </ApplicationFee>
              )
        case 4: 
              return(
                  <VideoAudition props={VideoAuditionProps}> </VideoAudition>
              )
        case 5: 
        return(
            <Signature props={SignatureProps}> </Signature>
        )
        default:
          return (
              <Typography> Unknown Step </Typography>
          );
      }

    }
    
  }


  return (
    <div className={classes.root}>
        <ThemeProvider theme={currentTheme}>
        {
          <Container component="main" maxWidth="lg">
            <CssBaseline />
            <AppBar
              position="fixed"
            >
              <Toolbar>
                <IconButton
                  color="inherit"
                  edge="end"
                  className={classes.menuButton}
                  onClick={handleHome}
                >
                  <HomeIcon />
                </IconButton>
                <Typography variant="h6" noWrap className={classes.title}>
                  <Box textAlign="left">
                    BIB XV Registration Portal
              </Box>
                </Typography>
                {completedVal && <Typography variant="h6" noWrap className={classes.title}>
                  <Box textAlign='center'>
                    Application completed!
                  </Box>
                </Typography>}
                <Typography variant="h6" noWrap className={classes.title}>
                  <Box textAlign="right" marginRight={2}>
                    Last saved: {snap.LastUpdated}
                  </Box>
                </Typography>
                <ButtonGroup color='primary' variant="contained">
                  <Button classes={{root: classes.logoutButton}} onClick={handleSignout}>  Logout </Button>
                </ButtonGroup>
              </Toolbar>
            </AppBar>
            <Box p={5} />
          </Container>
        }
      <Stepper nonLinear  activeStep={activeStep} >
        {steps.map((label, index) => (
          <Step key={label}>
            <StepButton onClick={handleStep(index)} completed={handleCompleted(index)}>
              {label}
            </StepButton>
          </Step>
        ))}
      </Stepper>
      <div>
        {allStepsCompleted() ? (
          <div>
            <Typography className={classes.instructions}>
              All steps completed - you&apos;re finished
            </Typography>
            <Button onClick={handleReset}>Reset</Button>
          </div>
        ) : (
          <div>
            <Box m={5}/>
            {getStepContent(activeStep)}
            <div>
            {show && <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
              <Button disabled={activeStep === 0} onClick={handleBack} className={classes.button}>
                Back
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={handleNext}
                className={classes.button}
              >
                Next
              </Button>
            
            </Grid>}
            </div>
          </div>
        )}
      </div>
      <Box mt={8} minHeight="100vh">

<Copyright />
</Box>
<Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">{"Application Completed!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Your application has been submitted. Your submission time is logged as the last saved time shown in the top right corner.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Okay
          </Button>
        </DialogActions>
      </Dialog>
      </ThemeProvider>

    </div>
  );
}